"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.statusesOptions = exports.orderStatusesOptions = exports.RETURN_PRODUCT_STATUSES = void 0;
exports.RETURN_PRODUCT_STATUSES = {
    requested: 1,
    in_progress: 2,
    returned: 3,
    declined: 4,
    rejected: 5,
    resolved: 7,
};
var orderStatusesOptions;
(function (orderStatusesOptions) {
    orderStatusesOptions[orderStatusesOptions["ORDER_PLACED"] = 0] = "ORDER_PLACED";
    orderStatusesOptions[orderStatusesOptions["IN_PRODUCTION"] = 2] = "IN_PRODUCTION";
    orderStatusesOptions[orderStatusesOptions["IN_TRANSIT"] = 3] = "IN_TRANSIT";
    orderStatusesOptions[orderStatusesOptions["DELIVERED"] = 4] = "DELIVERED";
    orderStatusesOptions[orderStatusesOptions["CANCELED"] = 42] = "CANCELED";
})(orderStatusesOptions || (exports.orderStatusesOptions = orderStatusesOptions = {}));
var statusesOptions;
(function (statusesOptions) {
    statusesOptions[statusesOptions["NEXT"] = 0] = "NEXT";
    statusesOptions[statusesOptions["IN_PROGRESS"] = 1] = "IN_PROGRESS";
    statusesOptions[statusesOptions["COMPLETED"] = 2] = "COMPLETED";
})(statusesOptions || (exports.statusesOptions = statusesOptions = {}));
